import styled from 'styled-components';
import {WindowSizePXEnum} from "../../interface/Basic/window";
import {Body1, Caption2, H3, ModalInfoDiscription, SecurityText, Subhead2, Title} from "../Font";
import {border, display} from "styled-system";
import {ListItemContainer, SelectDownList} from "./Select";

export const View = styled.div`
  margin: 112px auto 0 auto;
  max-width: 1136px;
  color: ${({theme}) => theme.color.primary};
  width: 1136px;

  @media (max-width: ${WindowSizePXEnum.md}) {
    width: auto;
    margin-top: 112px;
    margin-left: 32px;
    margin-right: 32px;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin-top: 80px;
    margin-left: 20px;
    margin-right: 20px;
  }
`

export const ContentLg = styled.div`
  margin: 32px 0;
`;
export const ContentXL = styled.div`
  margin: 48px 0;
`;
export const ContentXLTop = styled.div`
  margin-top: 48px;
`;
export const ContentXLMax749 = styled(ContentXL)`
  max-width: 749px;
`;
export const Content = styled.div`
  margin: 24px 0;
`;

export const ContentTop = styled.div`
  margin-top: 24px;
`;

export const ContentMd = styled.div`
  margin: 16px 0;
`;

export const ContentMd2Top = styled.div`
  margin: 18px 0;
`;
export const ContentTop16 = styled.div`
  margin-top: 16px;
`;
export const ContentXs = styled.div`
  margin: 12px 0;
`;

export const ContentXsTop = styled.div`
  margin-top: 12px;
`;
export const ContentXxs = styled.div`
  margin: 8px 0;
`;
export const ContentPd6 = styled.div`
  padding: 6px 0;
`;
export const MarginTop8 = styled.div`
  margin-top: 8px
`;
export const MarginTop6 = styled.div`
  margin-top: 6px
`;
export const Content4Top = styled.div`
  margin-top: 4px
`;
export const ContentXxxsTop = styled.div`
  margin-top: 4px
`;
export const ContentXXxxsTop = styled.div`
  margin-top: 2px
`;

export const FlexRow = styled.div`
  display: flex;
`
export const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`

export interface FlexColumnCenteredProps {
    filter?: string
}

export const FlexColumnCentered = styled.div<FlexColumnCenteredProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  filter: ${(props) => props.filter ? props.filter : 'none'};


  @media (max-width: ${WindowSizePXEnum.xs}) {
    filter: unset;
    -webkit-filter: unset;
  }

`
export const NewModal = styled.div<FlexColumnCenteredProps>`
  position: fixed;
  z-index:9999;

  /* фиксированное положение */
  inset: 0;
  background: rgb(0 0 0 / 38%);


  /* по умолчанию модальное окно прозрачно */
  display: flex;
  transition: all .3s ease-out;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    top: 58px;
  }
`


export const NewModalContainer = styled.div<FlexColumnCenteredProps>`
  width:400px;
  min-height: 250px;
  margin:auto;
  background:rgb(255,255,255);
  border-radius: 10px;
  padding: 24px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
    height: 100%;
    margin: 0;
    border-radius: 0;
  }
`

export const CloseMobile = styled.div`
  display: none;
  cursor: pointer;
  z-index: 2;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display: flex;
    position: absolute;
    right: 30px;
    top: 30px;
  }
`


export const FixedBottomBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: -120px;
  gap: 25px;
position: absolute;
  width: 100%;
  @media (max-width: ${WindowSizePXEnum.xxs}) {
    bottom: -90px;
    z-index: 2;
  }
`

export const Input = styled.input`
  height: 56px;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 96px;
`
export const FormLabel = styled.label`
  user-select: none;
  position: absolute;
  display: flex;
  color: ${({theme}) => theme.color.secondary};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  transition: 0.5s;
  top: 47%;
  transform: translateY(-35%);
  left: 10px;


`
export const PhoneLabel = styled.label`
  user-select: none;
  display: flex;
  color: ${({theme}) => theme.color.secondary};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  transition: 0.5s;
  top: 47%;
  transform: translateY(-35%);
  left: 10px;
  margin-top: 25px;
  margin-left: -7px;
  gap: 0;
  z-index: 10;
`

export interface InputContainerProps {
    border_color?: string
}

export const InputContainer = styled.div<InputContainerProps>`
  display: flex;
  position: relative;
  width: 100%;
  margin-bottom: 16px;
  border-width: 1px;
  border: ${({border_color}) => `1px solid ${border_color}`};
  border-radius: 4px;

  input {
    background: #FFF;
    width: 70%;
    box-sizing: border-box;
    padding: 20px 0 5px 8px;
    border: none;
    :focus {
      box-shadow: none;
      outline: none;
      border: none;
    }

    :disabled {
      cursor: not-allowed;
      background-color: #f8f8f8;
    }

    :focus ~ label,
    :not(:placeholder-shown) ~ label {
      font-size: 12px;
      transform: translateY(-20px);

    }
  }

  .phone-input-danger {

  }
`
export const EyeCircle = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) rotate(260deg);
  width: 5px;
  height: 5px;
  display: flex;
  border-radius: 50%;

  :after {
    position: absolute;
    bottom: 2px;
    right: 1px;
    width: 6px;
    height: 6px;
    background: #C4C7CB;
    border-radius: 50%;
    content: " ";
  }
`

export const FormFooter = styled.div`
  width: 100%;
  margin-top: 24px;
  padding-top: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  @media (max-height: 545px) {
    margin-top: 10px;
  }
`

export const FormGoBack = styled.div`
  position: absolute;
  left: 0;
  top: 8px;
  cursor: pointer;
  // @media (max-width: ${WindowSizePXEnum.xs}) {
  //   top: -41px;
  // }
  @media (max-height: 545px) {
    top: 24px;
  }
`

export interface AvatarProps {
    size: number
}

export const PhotoSvg = styled.svg`
  fill: none;
`
export const IconContent = styled.div`
  position: absolute;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
`
export const Layer = styled.div`
  position: absolute;
  width: 64px;
  height: 64px;
  border-radius: 50%;
`

export const FormAvatar = styled.div<AvatarProps>`
  display: flex;
  width: ${(props) => props.size + 'px'};
  height: ${(props) => props.size + 'px'};
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background-size: 100%;

  :hover {
    cursor: pointer;

    ${PhotoSvg} {
      fill: white;
    }

    ${Layer} {
      z-index: 5;
      cursor: pointer;
      background-color: ${({theme}) => theme.color.primary};
      opacity: 0.6;
    }
  }
`
export const SelectedFormAvatar = styled(FormAvatar)`
  ${PhotoSvg} {
    fill: white;
  }

  ${Layer} {
    z-index: 5;
    cursor: pointer;
    background-color: ${({theme}) => theme.color.primary};
    opacity: 0.6;
  }
`
export const AvatarImg = styled.img`
  width: 100%;
`

export const WithoutPhoto = styled(PhotoSvg)`
  fill: white
`
export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 280px;
  padding: 0 20px;

`
export const SelectHeader = styled.div`
  display: flex;
  padding: 12px;
  gap: 5px;
  align-items: center;
  justify-content: space-between;
width: 100%;

`
export const DateSelect = styled.div`
  display: flex;
  position: relative;
  width: 30%;
  :not(:first-child) {
    border-left: 1px solid rgba(0, 0, 0, 0.12);
  }
  :nth-child(2) {
    width: 40%;
  }

`
export const SelectItem = styled.div`
  display: flex;
  padding: 10px 20px;
  background: ${({theme}) => theme.color.primaryBackground};

  :hover {
    filter: brightness(.95);
  }

  :active {
    filter: brightness(.9);
  }
`

export const SelectBody = styled.div`
  display: flex;
  position: absolute;
  top: 30px;
  max-height: 200px;
  overflow-y: scroll;
  flex-direction: column;
  border-radius: 4px;
  padding: 0;
  background: ${({theme}) => theme.color.primaryBackground};
  border: 1px solid rgba(0, 0, 0, 0.12);

`


export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  .verifiedCard {
    :hover {
      background-color: rgba(235, 235, 235, 1)
    }
  }

  @media (max-width: ${WindowSizePXEnum.md}) {
    align-self: center;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    overflow-x: hidden;
    gap: 16px;
    width: 100%;
  }
`
export const ContentNotification = styled.div`
  display: flex;
  padding: 24px;
  border-radius: 8px;
  border: ${({theme}) => theme.border.default};
  gap: 12px;
  @media (max-width: ${WindowSizePXEnum.md}) {
    max-width: 704px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
    border: none;
  }
`
export const NotificationList = styled.div`
  display: flex;
  flex-direction: column;
  svg {
    min-height: 20px;
    min-width: 20px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {

  }
`

export interface UsernfoProps {
    cursor: string
}

export const UserInfo = styled.div<UsernfoProps>`
  gap: 16px;
  background: ${({theme}) => theme.color.primaryBackground};
  border-radius: 8px;
  padding: 24px;
  border: 0.5px solid rgba(0, 0, 0, 0.12);
  cursor: ${(props) => props.cursor};
  @media (max-width: ${WindowSizePXEnum.xs}) {
    border: none;
    flex-direction: column;
    margin:0 20px;
  }
`

export const UserInfoContainer=styled.div`
  display: flex;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    border: none;
    border-radius: 0;
    flex-direction: column;
  }
`
export const UserPhoto=styled.div`
  display: flex;
  
`

export const UserInfoContact=styled.div`
  
`

export const Hr = styled.hr`
  margin: 16px 0;
  border-top: 1px solid;
  opacity: 10%;
`;
export const UserInfoContent = styled.div`
  display: flex;
  flex-direction: column;
`
export const ContactPhoneEmail=styled.div`
  display: flex;
  margin-top: 16px;
`
export const ContactInfo=styled.div`
  display: flex;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
  }
`
export const TitlePhoneEmail=styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.30000001192092896px;
  text-align: left;
  width: 256px;
  color: #898F97;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: auto;
  }
`
export const DescrPhoneEmail=styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: -0.30000001192092896px;
  text-align: left;
  margin: 0 0 0 15px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin: 8px 0 0 0;
  }
`


export const Gap16 = styled.div`
  display: flex;
  align-items: center;
  gap: 16px
`
export const Gap8 = styled(Gap16)`
  gap: 8px
`
export const Gap32 = styled(Gap16)`
  gap: 32px
`
export const Gap24 = styled(Gap16)`
  gap: 24px
`

export interface AddnfoProps {
    background?: string
    cursor?: string
}
export interface AddnfoProps {
    background?: string
    cursor?: string
    height?: string
}

export const AddInfo = styled.div<AddnfoProps>`
  height: ${(props) => props.height ?? '160px'};
  width: 436px;
  display: flex;
  gap: 22px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  flex-direction: column;
  padding: 24px;
  background: ${(props) => props.background};

  :hover {
    cursor: ${(props) => props.cursor};
  }

  @media (max-width: ${WindowSizePXEnum.md}) {
    max-width: 336px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    height: unset;
    max-width: 767px;
    width: 100%;
    border-radius: 0;
    border: none;
  }
`

export const AddInfoContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex-wrap: wrap;
  align-content: flex-start;
  align-items: flex-start;
`
export const FlexColumnWidth100 = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%
`

export const FlexRowWidth100 = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px
`

export const FormRoundSpan = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 4px;
  width: 100%;
  padding: 12px 16px;
  margin-top: 12px;
  border-radius: 8px;
  background: ${({theme}) => theme.color.secondaryBackground};
`;
export const FormRoundSpanContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  
  ${Body1}, ${Caption2} {
    width: 80%;
    margin-left: 10px;
    text-align: start;
  }
`;
export const RegisterNotificationSpan = styled(FormRoundSpan)`
  align-items: flex-start;
  margin-bottom: 16px;
  padding: 18px 24px;
`

export const EmptyIcon = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
`

export const Radio = styled.input`
  width: 22px;
  height: 22px;
  margin: 0;
`

export const ModalInfoContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  min-height: 52px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  align-items: center;

  .passport-description {
    max-width: 80px;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    ${ModalInfoDiscription} {
      min-width: 112px;
    }
  }
`

export const ModalInfoContentBottom = styled(ModalInfoContent)`
  border-bottom: 0;
`

export const PersonInfoContent = styled.div`
  display: flex;
  gap: 16px;
`

export const UnionDiv = styled.div`
  :hover {
    cursor: pointer;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin-left: auto;
    margin-top: -60px;
  }
`
export const UserDataContent = styled.div`
  flex-direction: column;
  display: flex;
  gap: 16px;
  margin: 0 0 8px 20px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin: 7px 0 0 0;
    .personalInfoChange {
      max-width: 217px;
    }
  }

  .series {
    text-overflow: ellipsis;
  }
`

export const FAQModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 30px 24px 37px 24px;
  width: 592px;
  min-height: 248px;
  max-height: 707px;
  overflow-y: scroll;
  left: calc(50% - 592px / 2);
  top: 96px;
  background: ${({theme}) => theme.color.primaryBackground};
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  margin-bottom: 32px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    border-radius: unset;
    position: absolute;
    top: 0;
    left: 0;
    padding-top: 82px;
    width: 100%;
    height: 100vh;
    margin: 0;
    max-height: unset;
  }

`
export const FAQContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 80%;
  width: 100%;
`

export const FAQSolution = styled.div`
  margin-top: 26px;
  margin-bottom: 6px;
`

export const DropContent = styled.div`
  cursor: pointer;

  .dropUp {
    fill: #222222;
  }
`

export const SecurityModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  width: 592px;
  min-height: 312px;
  left: calc(50% - 592px / 2);
  top: 96px;
  background: ${({theme}) => theme.color.primaryBackground};
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    overflow: hidden;
    width: 100vw;
    height: auto;
    top: 0;
    left: 0;
    border: none;
    padding: 0px 20px;
    margin-top: -24px;
    border-radius: unset;
    height: 100vh;
  }
`

export const SecurityContent = styled.div`
  margin-top: 12px;
  width: 100%;
`

export const SecurityRow = styled.div`
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
`
export const SecurityRowContent = styled.div`
  padding: 16px 0;
  display: flex;
  justify-content: space-between;

  .securityDescription {
    min-width: 185px;
    max-width: 180px;
    @media (max-width: ${WindowSizePXEnum.xs}) {
      min-width: 80px;
    }
    @media (max-width: 319px) {
      max-width: 100px;
      ${SecurityText} {
        max-width: 100px;
      }
    }
  }

  @media (max-width: ${WindowSizePXEnum.md}) {
    max-width: 320px;
    gap: 12px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    max-width: unset;
    gap: 12px;
  }

`
export const SecurityBottomRow = styled(SecurityRow)`
  border-bottom: 0;
`

export const SecurityInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 271px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 159px;
  }
`

export const EditSecurityModal = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  position: absolute;
  width: 400px;
  min-height: 284px;
  left: calc(50% - 400px / 2 - 96px);
  top: 96px;
  background: ${({theme}) => theme.color.primaryBackground};
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  align-items: center;
  text-align: center;
  @media (max-width: ${WindowSizePXEnum.md}) {
    margin-left: 108px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding-top: 38px;
  }
`

export const ConfirmSecurityContent = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
`

export const SecurityTitleContent = styled.div`
  display: flex;
  width: 100%;
  gap: 75px;
  align-items: baseline;

  .security-icon {
    cursor: pointer;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
    padding-top: 40px;
    gap: 0;
    ${Title} {
      margin-top: 50px;
      width: 100%;
    }
  }
`

export const ModalsAddLink = styled(FlexRow)`
  cursor: pointer;
  gap: 16px;
  width: fit-content;

  :hover {
    filter: opacity(.8);
  }

  :active {
    filter: opacity(.7);
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    padding-left: 20px;
  }
`
export const ModalsTitleContent = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  align-items: baseline;

  .security-icon {
    cursor: pointer;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    .info-title {
      padding-top: 40px;
    }

    .info-icon {
      position: absolute;
      top: 24px;
    }
  }
`
export const ModalsAddForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px 24px 0 24px;
  position: absolute;
  width: 500px;
  min-height: 264px;
  left: calc(50% - 400px / 2 - 96px);
  top: 96px;
  background: ${({theme}) => theme.color.primaryBackground};
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  align-items: center;
  text-align: center;
  overflow: auto;
  margin-bottom: 200px;
  @media (max-width: ${WindowSizePXEnum.md}) {
    position: unset;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    position: absolute;
    width: 100%;
    height: 100vh;
    top: 0;
    padding-top: 96px;
    justify-content: flex-start;
    ${ModalsTitleContent} {
      margin-top: -10px;
      flex-direction: column;
      gap: 47px;
    }

    padding-bottom: 30px;
  }
`
export const FlagLabel = styled.label`
  align-self: center;
  z-index: 6;
  left: 16px;
`

export const FlagsMenuContainer = styled.div`
  position: absolute;
  z-index: 5;
  background: ${({theme}) => theme.color.primaryBackground};
  padding: 8px 0;
  border-radius: 4px;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  top: 34px;
  left: -30px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display: none;
  }
`

export const FlagsMenuItem = styled(FlexRow)`
  padding: 4px 8px;
  cursor: pointer;
  gap: 8px;
  width: 100%;

  :hover {
    background-color: ${({theme}) => theme.color.secondaryBackground};
  }
`

export interface PhoneInputProps {
    border?: string
}

export const PhoneInput = styled.div<PhoneInputProps>`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding: 0 16px;
  gap: 2px;
  width: 100%;
  height: 56px;
  ${border};
  border-radius: 4px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
`

export const FindUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  margin-bottom: 9px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin-top: 20px;
  }
`

export const FindUserImg = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  overflow: hidden;
  margin-bottom: 16px;
`

export const CaptchaContainer = styled.div`
  margin-top: 18px;
`

export const NoAccessContent = styled.div`
  margin-top: 16px;
  text-align: left;
`

export const PasswordSavingModalBackground = styled.div`
  opacity: 0.1;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: white;
  z-index: 5;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    background: none;
    opacity: 0;
  }
`
export const WarningInfo = styled.div`
  height: 102px;
  width: 454px;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  background: ${({theme}) => theme.color.secondaryBackground};
  padding: 18px 18px 24px 28px;
  margin-bottom: 16px;
`
export const WarningInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
`
export const EducationAndWorkCardInfo = styled(AddInfo)`
  min-height: 150px;
  height: unset;
  max-width: 434px;
  @media (max-width: ${WindowSizePXEnum.md}) {
    max-width: 336px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    max-width: unset;
  }
`
export const EducationWorkInfoContent = styled(AddInfoContent)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`
export const EducationWorkInfosContent = styled(AddInfoContent)`
  display: flex;
  flex-direction: column;
  column-gap: 71px;
  gap: 16px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
  }
`

export const ModalsFormContent = styled.div`
  padding-top: 24px;
  width: 100%;
  text-align: left;
`

export const ModalsFormItemContent = styled.div`
  margin-bottom: 24px;

  .career-input {
    padding: 0 8px;
  }

  .career-year {
    width: 214px;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
    .career-year {
      width: unset;
    }

    .date-start {

      ${SelectDownList} {
        position: relative;
        height: 300px;

        ${ListItemContainer} {
          max-height: 340px !important;
        }
      }
    }

    .date-end {
      ${SelectDownList} {
        top: 130px !important;
        height: 400px;

        ${ListItemContainer} {
          max-height: 340px !important;
        }
      }
    }
  }
`

export const FormBottomContent = styled.div`
  margin-top: 8px;
`
export const EducationFormFlex = styled(FlexRow)`
  width: 100%;
  gap: 24px;

  ${ModalsFormItemContent} {
    width: 100%;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
    gap: 0px;
  }
`

export const ModalsCardContainer = styled.div`
  width: 500px;
  max-height: 170px;
  background-color: ${({theme}) => theme.color.primaryBackground};
  box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.08);
  border-radius: 10px;
  padding: 24px;
  text-align-last: left;

  ${H3} {
    margin: 0 0 24px 0
  }

  ${Subhead2} {
    margin-bottom: 4px;
  }

  ${Body1} {
    margin-bottom: 4px;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 100%;
    max-width: unset;
    min-width: unset;
    border-radius: unset;
    max-height: unset;
  }
`

export const FAQContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

interface IAskForAccountFooterProps {
    display?: string
}

export const MobileFormFooter = styled(FormFooter)<IAskForAccountFooterProps>`
  display: none;
  align-items: center;
  justify-content: center;
  gap: 25px;
  background: none;
  ${display};
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display: flex;
  }
  @media (max-height: 467px) {
    bottom: 24px;
  }
`

export const CodeSelector = styled.div`
  position: absolute;
  top: 50px;
  left: -10px;
  z-index: 100;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.08), 0 2px 24px rgba(0, 0, 0, 0.08);
  background: ${({theme}) => theme.color.primaryBackground};
  @media (max-width: ${WindowSizePXEnum.xs}) {
    box-shadow: none;
    padding: 24px;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
`
export const CodeSelectorList = styled.div`
  max-height: 300px;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  max-width: 300px;
  width: 300px;
  background: ${({theme}) => theme.color.primaryBackground};
  @media (max-width: ${WindowSizePXEnum.xs}) {
    max-height: 90%;
max-width: 95%;
    width: 95%;
  }
`

export const PhoneCodeGoBack = styled.div`
  align-self: center;
`

export const RegisterAddAvatar = styled.div`
  padding-top: 24px;
  padding-left: 20px;
`

export const RegisterCutPhotoExit = styled.div`
  position: absolute;
  right: 24px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    top: 22px;
  }
`

export const RegisterFormFooter = styled(FormFooter)`
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display: none;
  }
`

export const CardContainer = styled(Gap32)`
  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`
export const GendersGap = styled(Gap24)`
  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
    gap: 0;
    align-items: flex-start;
  }
`


export const ModalTitleContent = styled.div`
  display: flex;
  width: 100%;
  gap: 24px;
  align-items: baseline;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    .modalIcon {
      position: absolute;
    }

    ${Title} {
      margin-top: 40px;
    }
  }
`

export const HeaderLang = styled(Gap8)`
  cursor: pointer;
`
export const DateSelectorBody = styled(SelectBody)`
  top: unset;
  bottom: 42px;
  width: 100%;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    bottom: 42px;
    top: unset;
    height: 400px;
    max-height: unset;
  }
`

export const AdditionalInfoContainer = styled(FlexColumn)`
  flex-direction: row;
  gap: 32px;
  align-items: flex-start;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
  }
`

export const SecurityInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
    margin-right: -18px;
  }
`

export const SecurityEmailContainer = styled.div`
  display: flex;
  flex-direction: column;
`
export const RecoveryCross = styled(FormGoBack)`
  right: 0;
  left: unset;
  cursor: pointer;
`
export const ModalsInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 37px;
  width: 100%;
`

export const CareerDatesContent = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
    margin-bottom: 24px;
  }
`

export const DropContainer = styled.div`
  @media (max-width: ${WindowSizePXEnum.xs}) {
    display: none;
  }
`
export const HeaderLogo = styled.div`
  @media (max-width: ${WindowSizePXEnum.xs}) {
    .logo {
      width: 94px;
      height: 48px;
    }
  }
`
export const HeaderLeft = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
  @media (max-width: ${WindowSizePXEnum.md}) {
    margin-left: 24px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin-left: 0;
    gap: 16px;
  }
`

export const HeaderRight = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
  @media (max-width: ${WindowSizePXEnum.md}) {
    margin-right: 24px;
  }
  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin-right: 0px;
    gap: 20px;
    ${FormAvatar} {
      width: 32px;
      height: 32px;
    }
  }
`

export const WorkEducationAddInfo = styled(AddInfo)`
  height: unset;
  min-height: 92px;
`

export const VerifiedCell = styled(FlexRow)`
  width: 221px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 0;
  }
`
export const ExternalSystemItem = styled(FlexRow)`
  min-height: 56px;
  align-items: center;
  padding: 16px 0 24px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  :hover {
    cursor: pointer;
    background-color: rgba(235, 235, 235, 1);
  }

  .name {
    width: 185px;
    .name-text{
      width: 120px;
    }
  }

  .access {
    width: 200px;
    align-self: center;
  }

  .access_loader {
    width: 160px;
    text-align: -webkit-center;
  }

  .access_icon {
    text-align: right;
  }

  .mobile-verified {
    display: none;
  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    .verified {
      display: none;
    }

    .mobile-verified {
      display: unset;
    }

    .access_loader {
      text-align: left;
    }

    .name-text {
      width: 120px;
    }
  }
`


export const ExternalSystemTable = styled(FlexColumn)`
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);;
  position: relative;
  .name {
    padding-left: 24px;
  }

  .access_icon {
    text-align-last: right;
  }

  .access {
    padding-right: 16px;
    text-align-last: right;
    width: 150px;
  }

  @media (max-width: 319px) {
    .access {
      padding-right: 14px;
      width: 140px;
      margin-right: -24px;
    }

  }

  @media (max-width: ${WindowSizePXEnum.xs}) {
    .name {
      padding-left: 20px;
    }

    .access {
      text-align-last: left;
      width: 156px;
      margin-right: -24px;
    }
  }
`

export const ExternalSystemModal = styled(SecurityModal)`
  margin-top: 32px;
  padding: 0px;
  height: unset;
  margin-bottom: 30px;
  margin-left: -2px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    padding-bottom: 56px;
    margin-left: 0px;
    margin-top: 8px;
    box-shadow: none;
  }
`

export const ExternalSystemCell = styled.div`
  padding: 0 8px 0 0;
`

export const ExternalSystemSynchronization = styled.div`
  padding: 16px 50px 24px 24px;
`

export const AdditionalSystemInfo = styled(FlexColumn)`
  padding-left: 24px;
  padding-top: 8px;
  gap: 24px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    padding-left: 20px;
  }
`

export const AdditionalSystemInfoItem = styled(FlexRow)`
  vertical-align: top;
  padding-bottom: 12px;
`

export const AddInfoTitle = styled(Body1)`
  width: 185px;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    width: 120px;
  }
`

interface SystemBorderProps {
    isLast: boolean
}

export const SystemBorder = styled.div<SystemBorderProps>`
  :after {
    position: absolute;
    content: '';
    border-bottom: ${(props) => props.isLast ? '' : '1px solid rgba(0, 0, 0, 0.12)'};
    width: calc(100% - 40px);
    transform: translateX(-50%);
    left: 50%;
  }
`

export const ModalsIconContent = styled.div`
  @media (max-width: ${WindowSizePXEnum.xs}) {
    margin-top: 32px;
  }
`

export const BoxIsolatedContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 19px 0 24px;
  width: 100%;
  max-height: 500px;
  overflow-y: scroll;
  @media (max-width: ${WindowSizePXEnum.xs}) {
    max-height: unset;
  }
`

export const IconContainer = styled.div`
  display: flex;

`
export const IconContainerPointer = styled(IconContainer)`
    cursor: pointer;
`
